import { useState, useContext } from "react";
import {
  Avatar,
  Badge,
  Button,
  Col,
  Input,
  Row,
} from "antd";
import {
  MenuOutlined,
} from "@ant-design/icons";
import { Search, Moon, LayoutGrid, Bell, PanelLeftClose, PanelLeftOpen } from "lucide-react";

import { useNavigate } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal";
import { Severty, ShowToast } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import { useAppContext } from "../../context/AppContext";

function Header({ onPress, setToggle, toggle, visible }) {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const getFromStorage = (key) => {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch {
      return null;
    }
  };
  const userProfile = getFromStorage("userProfile") || getFromStorage("user");
  const userName = userProfile?.full_name || userProfile?.name || "Example";
  const initial = userName.charAt(0).toUpperCase();

  return (
    <>
      <Row className="align-items-center" >
        <Col span={12} xs={18} md={12} style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <div className="moblile-toggle d-lg-none">
            <Button
              type="text"
              icon={visible ? <PanelLeftClose /> : <PanelLeftOpen />}
              onClick={() => onPress()}
              style={{ fontSize: "18px", color: "#64748b" }}
            />
          </div>
          <div className="d-none d-lg-block">
            <Button
              type="text"
              icon={toggle ? <PanelLeftOpen /> : <PanelLeftClose />}
              onClick={() => setToggle()}
              style={{ fontSize: "18px", color: "#64748b" }}
            />
          </div>

          {/* Mega Search */}
          {/* <Input
            placeholder="Mega Search"
            prefix={<Search size={16} color="#94a3b8" style={{ marginRight: 8 }} />}
            style={{
              borderRadius: "8px",
              background: "#fff",
              border: "1px solid #e2e8f0",
              maxWidth: "300px",
              padding: "8px 12px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.01)"
            }}
          /> */}
        </Col>

        <Col span={12} xs={6} md={12} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "24px" }}>
          {/* <Button type="text" style={{ padding: 0, color: "#64748b", display: "flex", alignItems: "center" }}>
            <Moon size={20} />
          </Button>
          <Button type="text" style={{ padding: 0, color: "#64748b", display: "flex", alignItems: "center" }}>
            <LayoutGrid size={20} />
          </Button>
          <Badge count={41} size="small" style={{ backgroundColor: '#1677ff' }}>
            <Button type="text" style={{ padding: 0, color: "#64748b", display: "flex", alignItems: "center" }}>
              <Bell size={20} />
            </Button>
          </Badge> */}

          <div className="profileDropdownMain" style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            <Avatar
              size={36}
              style={{ backgroundColor: '#3b82f6', color: '#fff', fontSize: '16px', fontWeight: 500 }}
            >
              {initial}
            </Avatar>
          </div>
        </Col>
      </Row>

      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to logout?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            ShowToast("Logout Successfully!", Severty.SUCCESS);
            logout();
          }}
        />
      )}
    </>
  );
}

export default Header;
